import React from 'react'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'

import './index.scss'


export default class Modal extends BaseComponent {
  constructor(props) {
    super(props)
    this._bind('_onClose')
  }

  _onClose() {
    if(this.context.isModalVisible && !this.context.isSecondModalVisible)
      this.context.hideModal()
    else if(this.context.isSecondModalVisible)
      this.context.hideSecondModal()

    if ( typeof this.props.onClose === 'function' )
      this.props.onClose()
  }

  _stopPropagation(e) {
    e.stopPropagation()
  }

  render() {
    return(
      <div id="Modal" className={`d-flex justify-content-center align-items-center section-containe ${this.props.className}`}>
        <div className="Modal__mask" onClick={this._onClose}></div>
        { this.props.children }
      </div>
    )
  }
}

Modal.defaultProps = {
  className: '',
}

Modal.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
}

Modal.contextTypes = {
  hideModal: PropTypes.func.isRequired,
  hideSecondModal: PropTypes.func.isRequired,
  isModalVisible: PropTypes.bool.isRequired,
  isSecondModalVisible: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js